import { render, staticRenderFns } from "./Copyable.vue?vue&type=template&id=77f5d5d8&scoped=true&"
import script from "./Copyable.vue?vue&type=script&lang=js&"
export * from "./Copyable.vue?vue&type=script&lang=js&"
import style0 from "./Copyable.vue?vue&type=style&index=0&id=77f5d5d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f5d5d8",
  null
  
)

export default component.exports